import RetailerProductPricing from './RetailerProductPricing';

export default RetailerProductPricing;
